import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {
  BI_ORIGINS,
  ChangeRsvpModalMode,
  MembersModal,
  getEventId,
  getEventTitle,
  isNoResponseEnabled,
} from '@wix/wix-events-commons-statics'
import {setActiveElement} from '../../../../commons/actions/focus-handler'
import {setToast} from '../../../../commons/actions/toast-handler'
import {isPreview} from '../../../../commons/selectors/environment'
import {openDialogModal, openModal} from '../../../../commons/services/modal'
import {getEventRsvp} from '../selectors/event'
import {createAsyncAction} from '../services/redux-toolkit'
import {DetailedEvent} from '../types/state'

interface CancelRsvpArgs {
  event: DetailedEvent
  returnFocusElement?: string
}

export const openCancelRsvpModal = createAsyncAction<void, CancelRsvpArgs>(
  'OPEN_CANCEL_RSVP_MODAL',
  async ({event, returnFocusElement}, {getState, dispatch}) => {
    const eventId = getEventId(event.event)
    const eventTitle = getEventTitle(event.event)
    const state = getState()

    if (isPreview(state)) {
      await dispatch(
        openModal({
          type: MembersModal.NO_CANCEL_RSVP,
          params: {eventId, origin: BI_ORIGINS.MEMBERS_AREA},
        }),
      ).unwrap()
      dispatch(setActiveElement(hookToAttributeSelector(returnFocusElement)))
    } else {
      return dispatch(
        openDialogModal({
          type: MembersModal.UPDATE_RSVP,
          params: {eventId, eventTitle, mode: ChangeRsvpModalMode.MEMBERS_PAGE, origin: BI_ORIGINS.MEMBERS_AREA},
          onConfirm: async () => {
            try {
              await dispatch(onConfirmUpdateRsvp(event)).unwrap()
              dispatch(setToast({skin: 'success', titleKey: 'events.toast.rsvp-cancelled'}))
            } catch (e) {
              dispatch(setToast({skin: 'error', titleKey: 'events.toast.failed-to-cancel-rsvp'}))
              throw e
            }
          },
          returnFocusElement,
        }),
      ).unwrap()
    }
  },
)

export const cancelRsvp = createAsyncAction<{eventId: string}, {eventId: string; rsvpId: string}>(
  'CANCEL_RSVP',
  async ({eventId, rsvpId}, {extra: {serverApi}}) => serverApi.cancelRsvp({eventId, rsvpId}),
)

export const deleteRsvp = createAsyncAction<{eventId: string}, {eventId: string; rsvpId: string}>(
  'DELETE_RSVP',
  async ({eventId, rsvpId}, {extra: {serverApi}}) => serverApi.deleteRsvp({eventId, rsvpId}),
)

const onConfirmUpdateRsvp = (event: DetailedEvent) => {
  const eventId = getEventId(event.event)
  const rsvpId = getEventRsvp(event).id

  return isNoResponseEnabled(event.event) ? cancelRsvp({eventId, rsvpId}) : deleteRsvp({eventId, rsvpId})
}
